import { app } from '../../app';
import { Controller } from './sp-editable-password.controller';

app.component('spEditablePassword', {
    bindings: {
        initialValue: '<',
        isPasswordHidden: '<',
        inputMaxLength: '<',
        adminCantSeePassword: '<',
        inputPattern: '<',
        isOptional: '<',
        isReadOnly: '<',
        generateAvailable: '<',
        onGenerate: '&?',
        onSave: '&',
        patternWarningKey: '<',
    },
    controller: Controller,
    templateUrl: require('./sp-editable-password.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-editable-password/sp-editable-password.component.js